import { useContext, useMemo, useState } from 'react';
import { addDays, endOfDay, format, isPast, isSameDay } from 'date-fns';
import {
    formatDateTimeLong,
    formatTime,
    minutesToDuration,
} from '~/lib/DateTime';
import BoldChevronLeftIcon from '~/components/icons/BoldChevronLeftIcon';
import BoldChevronRightIcon from '~/components/icons/BoldChevronRightIcon';
import Modal from '~/components/Modal';
import { SelectionImage } from '~/components/forms/questions/components/SelectionBlock';
import ClassDescription, {
    ClassSpotsLeft,
    ClassTitle,
    isInstanceSelected,
} from '~/components/forms/questions/scheduling/ClassDescription';
import ClassBookButton from '~/components/forms/questions/scheduling/ClassBookButton';
import { FormContext } from '~/components/forms/FormContext';
import ThemedForm from '~/components/forms/ThemedForm';
import { useWindowSize } from 'usehooks-ts';
import { truncate } from '~/lib/Utils';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import HeadingPreviousNext from '~/components/forms/questions/scheduling/HeadingPreviousNext.jsx';
import DayHeading from '~/components/forms/questions/scheduling/DayHeading.jsx';
import SingleClassBlock from '~/components/forms/questions/scheduling/SingleClassBlock.jsx';
import ClassViewModal from '~/components/forms/questions/scheduling/ClassViewModal.jsx';

// const DayHeading = ({ date }) => {
//     const isInPast = isPast(endOfDay(date));
//     return (
//         <div
//             className={`text-center bg-gray-200 rounded-lg min-h-12 py-2 ${isInPast ? 'text-gray-500' : ''}`}
//         >
//             <div>{format(date, 'EEEE')}</div>
//             <div className="font-medium">{format(date, 'MMM d')}</div>
//         </div>
//     );
// };

const DayColumn = ({
    date,
    classes,
    selectedClasses,
    onSelectClass,
    settings,
    className,
    clientTz,
}) => {
    return (
        <div className={`flex-1 ${className}`}>
            <DayHeading date={date} />
            {classes.map(instance => (
                <SingleClassBlock
                    key={instance.id}
                    instance={instance}
                    onClick={() => onSelectClass(instance)}
                    settings={settings}
                    selectedClasses={selectedClasses}
                    clientTz={clientTz}
                />
            ))}
        </div>
    );
};

const WeeklyClassList = ({
    start,
    end,
    onPrevious,
    onNext,
    allClasses,
    selectedClasses,
    onSelectClass,
    onRemoveClass,
    settings,
    clientTz,
}) => {
    const [viewingClass, setViewingClass] = useState(null);

    let classesByDate = useMemo(() => {
        let result = [];
        let current = start;
        do {
            result.push({
                date: current,
                classes: allClasses.filter(i => isSameDay(i.start, current)),
            });
            current = addDays(current, 1);
        } while (current <= end);

        return result;
    }, [start, end, allClasses]);

    const { width } = useWindowSize();
    //const margin = Math.min(Math.max(0, width - 767), 200) / 2;

    return (
        <div className="w-[1000px]">
            <HeadingPreviousNext
                className="mb-2"
                onPrevious={onPrevious}
                onNext={onNext}
                start={start}
                end={end}
            />
            <div className="grid grid-cols-7 space-x-4">
                {classesByDate.map(data => (
                    <DayColumn
                        key={data.date.toISOString()}
                        date={data.date}
                        classes={data.classes}
                        onSelectClass={setViewingClass}
                        selectedClasses={selectedClasses}
                        settings={settings}
                        clientTz={clientTz}
                    />
                ))}
            </div>
            <ClassViewModal
                isOpen={!!viewingClass}
                instance={viewingClass}
                onClose={() => setViewingClass(null)}
                onSelect={onSelectClass}
                onRemoveClass={onRemoveClass}
                selectedClasses={selectedClasses}
                settings={settings}
                clientTz={clientTz}
            />
        </div>
    );
};

export default WeeklyClassList;
